/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReopenVendorErrorCodeRequestDto
 */
export interface ReopenVendorErrorCodeRequestDto {
    /**
     * Audit remark written on the linked unresolved row when Reopen transitions it RESOLVED → IN_REVIEW
     * @type {string}
     * @memberof ReopenVendorErrorCodeRequestDto
     */
    remark: string;
    /**
     * Optimistic concurrency version of the linked unresolved record (must match current version; mismatch → 409)
     * @type {number}
     * @memberof ReopenVendorErrorCodeRequestDto
     */
    expectedVersion: number;
}

/**
 * Check if a given object implements the ReopenVendorErrorCodeRequestDto interface.
 */
export function instanceOfReopenVendorErrorCodeRequestDto(value: object): value is ReopenVendorErrorCodeRequestDto {
    if (!('remark' in value) || value['remark'] === undefined) return false;
    if (!('expectedVersion' in value) || value['expectedVersion'] === undefined) return false;
    return true;
}

export function ReopenVendorErrorCodeRequestDtoFromJSON(json: any): ReopenVendorErrorCodeRequestDto {
    return ReopenVendorErrorCodeRequestDtoFromJSONTyped(json, false);
}

export function ReopenVendorErrorCodeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReopenVendorErrorCodeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'remark': json['remark'],
        'expectedVersion': json['expectedVersion'],
    };
}

export function ReopenVendorErrorCodeRequestDtoToJSON(json: any): ReopenVendorErrorCodeRequestDto {
    return ReopenVendorErrorCodeRequestDtoToJSONTyped(json, false);
}

export function ReopenVendorErrorCodeRequestDtoToJSONTyped(value?: ReopenVendorErrorCodeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remark': value['remark'],
        'expectedVersion': value['expectedVersion'],
    };
}

